import { Form } from "@redriver/cinnamon-mui";
import { industriesLookup } from "modules/lookups";

const IndustryDropdown = (props) => (
  <Form.Dropdown search lookup={industriesLookup} {...props} />
);

export default IndustryDropdown;
